import { isThreadListMember } from '../thread-list-member/isThreadListMember';
export const isHelpDeskViewMember = viewMember => {
  return !isThreadListMember(viewMember) && viewMember['@type'] === 'HELPDESK_VIEW_MEMBER';
};
export const isHelpDeskSearchViewMember = viewMember => {
  return !isThreadListMember(viewMember) && viewMember['@type'] === 'HELPDESK_SEARCH_VIEW_MEMBER';
};